import React, { ReactNode } from 'react'

export interface ICalcContainerProps {
  children: ReactNode
}

const CalcContainer = ({ children }: ICalcContainerProps) => (
  <div className='csas-wrapper csas-section'>
    <div className='csas-calc-loan csas-mb-md' data-testid='calc-container'>
      {children}
    </div>
  </div>
)

export default CalcContainer
